import api from './api';

const userService = {
  // Récupération de tous les utilisateurs (admin)
  getUsers: async (params = {}) => {
    return await api.get('/users', { params });
  },
  
  // Récupération d'un utilisateur par ID (admin)
  getUserById: async (userId) => {
    try {
      const response = await api.get(`/users/${userId}`);
      return response;
    } catch (error) {
      console.error(`Erreur lors de la récupération de l'utilisateur ${userId}:`, error);
      throw error;
    }
  },
  
  // Création d'un utilisateur (admin)
  createUser: async (userData) => {
    return await api.post('/users', userData);
  },
  
  // Mise à jour d'un utilisateur (admin)
  updateUser: async (userId, userData) => {
    return await api.put(`/users/${userId}`, userData);
  },
  
  // Suppression d'un utilisateur (admin)
  deleteUser: async (userId) => {
    return await api.delete(`/users/${userId}`);
  },
  
  // Invitation d'un utilisateur (admin)
  inviteUser: async (invitationData) => {
    return await api.post('/users/invite', invitationData);
  },
  
  // Récupération des invitations en attente (admin)
  getPendingInvitations: async () => {
    return await api.get('/users/invitations/pending');
  },
  
  // Suppression d'une invitation (admin)
  deleteInvitation: async (invitationId) => {
    return await api.delete(`/users/invitations/${invitationId}`);
  },

  // Vacances d'un utilisateur (admin)
  sendPasswordReset: async (userId) => api.post(`/users/${userId}/send-reset-password`),
  resendVerificationEmail: async (userId) => api.post(`/users/${userId}/resend-verification`),

  getUserVacations: async (userId) => api.get(`/users/${userId}/vacations`),
  createUserVacation: async (userId, data) => api.post(`/users/${userId}/vacations`, data),
  updateUserVacation: async (userId, vacationId, data) => api.put(`/users/${userId}/vacations/${vacationId}`, data),
  deleteUserVacation: async (userId, vacationId) => api.delete(`/users/${userId}/vacations/${vacationId}`)
};

export default userService;